function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactModal from 'react-modal';
import { PropTypes } from 'prop-types';
import cx from 'classnames';
import { AdaptiveListener } from 'xps-react-utils';
import Button from '../Button';
import Icon from '../Icon';
import ModalFullscreen from './ModalFullscreen';

require('xps-style/core/modal.css');

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMobileSize", function () {
      return _this.updateScreenSize('mobile');
    });

    _defineProperty(_assertThisInitialized(_this), "onTabletSize", function () {
      return _this.updateScreenSize('tablet');
    });

    _defineProperty(_assertThisInitialized(_this), "onDesktopSize", function () {
      return _this.updateScreenSize('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "setBodyRef", function (el) {
      _this.body = el;
    });

    _defineProperty(_assertThisInitialized(_this), "updateScreenSize", function (screenSize) {
      var modalType = _this.props.modalType;
      var updatedSize = modalType || screenSize;
      return _this.setState({
        screenSize: updatedSize
      });
    });

    _this.state = {
      screenSize: ''
    };

    _this.setAppElement();

    return _this;
  }

  _createClass(Modal, [{
    key: "setAppElement",
    value:
    /** Fix for setAppElement console warning.
     *  Sets appElement to props.rootAppElement (if found), #app (if found), or 'body' */
    function setAppElement() {
      var rootAppElement = this.props.rootAppElement;
      var fallback = 'body';

      if (rootAppElement !== fallback) {
        // this will crash app if rootAppElement isn't found 😬
        ReactModal.setAppElement(rootAppElement);
        return;
      } // else, see if #app is available


      var appId = '#app';
      var appIdFound = document.querySelector(appId);

      if (appIdFound) {
        ReactModal.setAppElement(appId);
      } else {
        ReactModal.setAppElement(fallback);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx2;

      var _this$props = this.props,
          alert = _this$props.alert,
          alertIcon = _this$props.alertIcon,
          alertIconType = _this$props.alertIconType,
          isOpen = _this$props.isOpen,
          label = _this$props.label,
          children = _this$props.children,
          className = _this$props.className,
          size = _this$props.size,
          header = _this$props.header,
          footer = _this$props.footer,
          id = _this$props.id,
          showCloseButton = _this$props.showCloseButton,
          fullscreenOnMobile = _this$props.fullscreenOnMobile,
          expandedMobileHeader = _this$props.expandedMobileHeader,
          onRequestClose = _this$props.onRequestClose,
          shouldCloseOnOverlayClick = _this$props.shouldCloseOnOverlayClick,
          showDividerLine = _this$props.showDividerLine,
          closeTimeoutMS = _this$props.closeTimeoutMS,
          overlayClassName = _this$props.overlayClassName,
          onAfterOpen = _this$props.onAfterOpen,
          mobileAppBarActions = _this$props.mobileAppBarActions,
          useBackButtonOnMobile = _this$props.useBackButtonOnMobile;
      var screenSize = this.state.screenSize;
      var contentClassName = cx(_defineProperty({
        modal__content: true
      }, "modal__content--".concat(size), !fullscreenOnMobile || screenSize !== 'mobile'), className);
      var overlayClass = cx({
        'modal--fullscreen': fullscreenOnMobile,
        'modal--windowed': !fullscreenOnMobile,
        modal__overlay: true,
        'modal__overlay-skin': true
      }, overlayClassName);
      var headerClassName = cx({
        modal__header: true,
        'modal__header-skin': true,
        'border-bottom': showDividerLine && !alert,
        'modal__header-skin--alert': alert
      });
      var headerTitleClassName = cx((_cx2 = {}, _defineProperty(_cx2, size === 'large' && screenSize !== 'mobile' ? 'h2' : 'h3', true), _defineProperty(_cx2, 'display-inlineblock', true), _cx2));
      var bodyClassName = cx({
        modal__body: true,
        'modal__body-skin': true,
        'paddingtop-md': !showDividerLine,
        'paddingbottom-lg': !showDividerLine,
        'paddingtop-xl': showDividerLine || alert,
        'paddingbottom-xl': showDividerLine
      });
      var footerClassName = cx({
        modal__footer: true,
        'modal__footer-skin': true,
        'border-top': showDividerLine,
        'modal__footer-skin--alert': alert
      });
      var renderFooter = footer && /*#__PURE__*/React.createElement("div", {
        className: footerClassName
      }, footer);
      return /*#__PURE__*/React.createElement(ReactModal, {
        isOpen: isOpen,
        onAfterOpen: onAfterOpen,
        onRequestClose: onRequestClose,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        closeTimeoutMS: closeTimeoutMS,
        className: contentClassName,
        overlayClassName: overlayClass,
        contentLabel: label,
        role: alert ? 'alertdialog' : 'dialog',
        id: id,
        aria: {
          describedby: "__".concat(id, "__modal__body__"),
          labelledby: "__".concat(id, "__modal__header__")
        }
      }, /*#__PURE__*/React.createElement(AdaptiveListener, {
        onMobileSize: this.onMobileSize,
        onTabletSize: this.onTabletSize,
        onDesktopSize: this.onDesktopSize
      }, screenSize === 'mobile' && fullscreenOnMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalFullscreen, {
        header: header,
        onRequestClose: onRequestClose,
        bodyRef: this.setBodyRef,
        expandedHeader: expandedMobileHeader,
        id: id,
        bodyClassname: "".concat(!footer ? 'modal__body--noFooter' : ''),
        appBarActions: mobileAppBarActions,
        useBackButtonOnMobile: useBackButtonOnMobile
      }, children), renderFooter) : /*#__PURE__*/React.createElement("div", {
        className: "modal__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: headerClassName,
        id: "__".concat(id, "__modal__header__")
      }, typeof header === 'string' ? /*#__PURE__*/React.createElement("div", {
        className: "display-flex align-items-center"
      }, alertIcon && /*#__PURE__*/React.createElement(Icon, {
        name: alertIcon,
        type: alertIconType,
        className: "marginright-lg icon--size-24 align-self-start"
      }), /*#__PURE__*/React.createElement("h1", {
        className: headerTitleClassName
      }, header)) : header, showCloseButton && /*#__PURE__*/React.createElement(Button, {
        name: "close",
        size: "medium",
        icon: "only",
        kind: "borderless",
        iconName: "close",
        className: "modal__header__closebtn",
        onClick: onRequestClose
      })), /*#__PURE__*/React.createElement("div", {
        className: bodyClassName,
        id: "__".concat(id, "__modal__body__"),
        ref: this.setBodyRef
      }, children), renderFooter)));
    }
  }]);

  return Modal;
}(React.Component);

_defineProperty(Modal, "propTypes", {
  /** toggles whether it is a default or alert modal */
  alert: PropTypes.bool,

  /** Icon name that will show up on the header */
  alertIcon: PropTypes.string,

  /** Type of icon based on its purpose (success, warning, error, or info) */
  alertIconType: PropTypes.oneOf(['success', 'warning', 'error', 'info']),

  /** controls the active state of the modal */
  isOpen: PropTypes.bool,

  /** toggles the display of the close button within the modal header */
  showCloseButton: PropTypes.bool,

  /** a function that runs after opening the modal */
  onAfterOpen: PropTypes.func,

  /** a function that is to be ran to close the modal, this should be used to toggle your isOpen state */
  onRequestClose: PropTypes.func,

  /** Number indicating the milliseconds to wait before closing the modal. */
  closeTimeoutMS: PropTypes.number,

  /** adds a label for better accessibility */
  label: PropTypes.string.isRequired,

  /** required for setting aria-* accessibility options */
  id: PropTypes.string.isRequired,

  /** refers to the top bar of the modal, here you can pass in a title or instructions via elements/components */
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,

  /** refers to the bottom bar of the modal, here you can pass your action items and buttons */
  footer: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /** sets the default max size of the modal */
  size: PropTypes.oneOf(['large', 'small']).isRequired,
  className: PropTypes.any,
  overlayClassName: PropTypes.string,

  /** body content of the modal */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /** sets fullscreen or windowed for mobile devices only */
  fullscreenOnMobile: PropTypes.bool,

  /** display header on modal body on mobile screen when set true */
  expandedMobileHeader: PropTypes.bool,

  /** render app bar action items on mobile */
  mobileAppBarActions: PropTypes.func,

  /** toggles whether or not clicking outside the modal closes it */
  shouldCloseOnOverlayClick: PropTypes.bool,

  /** show divider lines below modal header and above modal footer */
  showDividerLine: PropTypes.bool,

  /** query selector identifying the root of your app, ie: '#root' or '.root' */
  rootAppElement: PropTypes.string,

  /** Changes close button to back arrow for mobile devices only */
  useBackButtonOnMobile: PropTypes.bool,

  /** Select mobile, tablet or desktop modal type (optional) */
  modalType: PropTypes.oneOf(['mobile', 'tablet', 'desktop'])
});

_defineProperty(Modal, "defaultProps", {
  showCloseButton: true,
  onAfterOpen: function onAfterOpen() {},
  fullscreenOnMobile: true,
  shouldCloseOnOverlayClick: true,
  closeTimeoutMS: 0,
  rootAppElement: 'body'
});

export { Modal as default };
Modal.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onMobileSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTabletSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDesktopSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "setBodyRef",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "el",
      "type": null
    }],
    "returns": null
  }, {
    "name": "setAppElement",
    "docblock": "Fix for setAppElement console warning.\n Sets appElement to props.rootAppElement (if found), #app (if found), or 'body'",
    "modifiers": [],
    "params": [],
    "returns": null,
    "description": "Fix for setAppElement console warning.\n Sets appElement to props.rootAppElement (if found), #app (if found), or 'body'"
  }, {
    "name": "updateScreenSize",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "screenSize",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Modal",
  "props": {
    "showCloseButton": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "toggles the display of the close button within the modal header"
    },
    "onAfterOpen": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "a function that runs after opening the modal"
    },
    "fullscreenOnMobile": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "sets fullscreen or windowed for mobile devices only"
    },
    "shouldCloseOnOverlayClick": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "toggles whether or not clicking outside the modal closes it"
    },
    "closeTimeoutMS": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Number indicating the milliseconds to wait before closing the modal."
    },
    "rootAppElement": {
      "defaultValue": {
        "value": "'body'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "query selector identifying the root of your app, ie: '#root' or '.root'"
    },
    "alert": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "toggles whether it is a default or alert modal"
    },
    "alertIcon": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Icon name that will show up on the header"
    },
    "alertIconType": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'success'",
          "computed": false
        }, {
          "value": "'warning'",
          "computed": false
        }, {
          "value": "'error'",
          "computed": false
        }, {
          "value": "'info'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Type of icon based on its purpose (success, warning, error, or info)"
    },
    "isOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "controls the active state of the modal"
    },
    "onRequestClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "a function that is to be ran to close the modal, this should be used to toggle your isOpen state"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "adds a label for better accessibility"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "required for setting aria-* accessibility options"
    },
    "header": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": true,
      "description": "refers to the top bar of the modal, here you can pass in a title or instructions via elements/components"
    },
    "footer": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "refers to the bottom bar of the modal, here you can pass your action items and buttons"
    },
    "size": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": true,
      "description": "sets the default max size of the modal"
    },
    "className": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "overlayClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }, {
          "name": "node"
        }]
      },
      "required": false,
      "description": "body content of the modal"
    },
    "expandedMobileHeader": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "display header on modal body on mobile screen when set true"
    },
    "mobileAppBarActions": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render app bar action items on mobile"
    },
    "showDividerLine": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "show divider lines below modal header and above modal footer"
    },
    "useBackButtonOnMobile": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Changes close button to back arrow for mobile devices only"
    },
    "modalType": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'mobile'",
          "computed": false
        }, {
          "value": "'tablet'",
          "computed": false
        }, {
          "value": "'desktop'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Select mobile, tablet or desktop modal type (optional)"
    }
  }
};